class NavMenuHover extends HTMLElement {
  constructor() {
    super();
    this.menuItemLink = this.querySelector('.menu-item-link');
    this.submenu = this.querySelector('.submenu');
    this.hideTimeout = null;
    this.init();
  }

  init() {
    if (!this.menuItemLink || !this.submenu) return;

    this.menuItemLink.addEventListener('mouseenter', () => {
      clearTimeout(this.hideTimeout);
      this.submenu.classList.add('is-visible');
    });

    this.submenu.addEventListener('mouseenter', () => {
      clearTimeout(this.hideTimeout);
      this.submenu.classList.add('is-visible');
    });

    this.menuItemLink.addEventListener('mouseleave', () => {
      this.startHideTimeout();
    });

    this.submenu.addEventListener('mouseleave', () => {
      this.startHideTimeout();
    });
  }

  startHideTimeout() {
    this.hideTimeout = setTimeout(() => {
      this.submenu.classList.remove('is-visible');
    }, 300);
  }
}

customElements.define('nav-menu-hover', NavMenuHover);
